module.exports = __webpack_public_path__ + "img/code-bg.dd95d667.png";